import { flex, tablet } from '@faxi/web-css-utilities';
import { Card } from 'components/_molecules/Card/Card.styled';
import styled, { css } from 'styled-components';

const StyledBenefitCard = styled(Card)`
  background-color: var(--BACKGROUND_3_1);
  ${tablet(css`
    ${flex('column', 'flex-start', 'center')}
    .cedolauto-card {
      &__title,
      &__icon {
        margin-left: 0;
      }
    }
  `)}
`;

export { StyledBenefitCard };
